// src/pages/WishlistPage.js
/* eslint-disable */
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { removeFromWishlist, setWishlist } from "../redux/wishlistSlice";
import {
  Box,
  Typography,
  Button,
  Grid,
  Card,
  CardMedia,
  CardContent,
} from "@mui/material";

const WishlistPage = () => {
  const wishlist = useSelector((state) => state.wishlist.wishlist);
  const dispatch = useDispatch();

  useEffect(() => {
    loadWishlistFromLocalStorage(); // Load wishlist from local storage on component mount
  }, []);

  useEffect(() => {
    saveWishlistToLocalStorage(); // Save wishlist to local storage whenever it changes
  }, [wishlist]);

  const saveWishlistToLocalStorage = () => {
    localStorage.setItem("wishlist", JSON.stringify(Array.from(wishlist)));
  };

  const loadWishlistFromLocalStorage = () => {
    const storedWishlist = localStorage.getItem("wishlist");
    if (storedWishlist) {
      dispatch(setWishlist(JSON.parse(storedWishlist))); // Set wishlist from local storage
    }
  };

  const handleRemoveFromWishlist = (productId) => {
    dispatch(removeFromWishlist(productId));
  };

  return (
    <Box sx={{ p: 2, backgroundColor: "#eef2f6" }}>
      <Card>
        <Typography variant="h4" sx={{ p: 2 }}>
          Wishlist
        </Typography>
      </Card>
      {wishlist.length === 0 ? (
        <Card>
          <Typography variant="body1 " sx={{ p: 2 }}>
            No items in wishlist
          </Typography>
        </Card>
      ) : (
        <Grid container spacing={2}>
          {wishlist.map((item) => (
            <Grid item key={item.id} xs={12}>
              <Card
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "70%",
                  margin: "auto",
                  mt: 2,
                  p: 2,
                }}
              >
                <CardMedia
                  component="img"
                  image={item.imgSrc} // Assuming you have imgSrc in your wishlist item
                  alt={item.title} // Assuming you have title in your wishlist item
                  sx={{
                    height: 100,
                    width: "auto",
                    objectFit: "contain",
                  }}
                />
                <CardContent
                  sx={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    marginLeft: 1,
                  }}
                >
                  <Box>
                    <Typography variant="author1" gutterBottom noWrap>
                      {item.title} {/* Display title */}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 1 }}
                    >
                      {item.author} {/* Display author */}
                    </Typography>
                    <Typography
                      variant="h6"
                      color="text.primary"
                      sx={{ mb: 1 }}
                    >
                      ₹{item.price} {/* Display price */}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      onClick={() => handleRemoveFromWishlist(item.id)}
                    >
                      Remove {/* Button to remove from wishlist */}
                    </Button>
                    <Button
                      variant="outlined"
                      color="secondary"
                      size="small"
                      sx={{ ml: 1 }}
                    >
                      Add to Cart {/* Button to add to cart */}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default WishlistPage;
